export default __webpack_public_path__ + "static/login-1a09e0684d567c1eb9117b7bb63af38e.png";